import React, { useState, useEffect } from 'react';
import InputField from '../../../../forms/inputField';
import { updateUser } from '../../../../../client/users';
import { MODALS } from '../../../../../config/images';
const ModalEditGuest = ({ showModal, user, onClose, onSave, setSuccessMessage, setShowModalSuccess }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    user_code: '',
    personnel_division: '',
    position: '',
    email: '',
    hierarchichal_manage: '',
    functional_area: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      setFormData({
        fullName: user.fullName || '',
        user_code: user.user_code || '',
        personnel_division: user.personnel_division || '',
        position: user.position || '',
        email: user.email || '',
        hierarchichal_manage: user.hierarchichal_manage || '',
        functional_area: user.functional_area || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (!formData.fullName.trim()) {
        setError('El campo "Nombre completo" es obligatorio');
        setLoading(false);
        return;
      }

      if (!formData.email.trim()) {
        setError('El campo "Correo electrónico" es obligatorio');
        setLoading(false);
        return;
      }

      const updateData = {
        roleId: 4, // Rol invitado
        name: formData.fullName,
        email: formData.email,
        user_code: formData.user_code || null,
        personnel_division: formData.personnel_division || null,
        position: formData.position || null,
        hierarchichal_manage: formData.hierarchichal_manage || null,
        functional_area: formData.functional_area || null
      };


      const response = await updateUser(user.id, updateData);
      
      if (response.status === 200) {
        setSuccessMessage('Usuario invitado actualizado correctamente');
        setShowModalSuccess(true);
        onSave({
          ...user,
          id: user.id,
          name: formData.fullName,
          email: formData.email,
          user_code: formData.user_code,
          personnel_division: formData.personnel_division,
          position: formData.position,
          hierarchichal_manage: formData.hierarchichal_manage,
          functional_area: formData.functional_area
        });
        onClose();
      }
    } catch (err) {
      console.error('Error al actualizar usuario:', err);
      setError(err.response?.data?.message || 'Error al actualizar el usuario');
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[80vh] overflow-y-auto bg-white rounded-2xl">
        <div className="flex justify-end w-full p-2 ">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='px-6 pb-6'>
            <h2 className="text-2xl font-itcbold text-blue">Editar Usuario Invitado</h2>
    
            <form onSubmit={handleSubmit} className="flex flex-col gap-2 pt-4">
            
            <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
              <InputField
                title="Nombre completo"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                validation="letters-only"
                placeholder="Ingrese nombre completo"
                horizontal={false}
                required={true}
              />
              
              <InputField
                title="Código"
                name="user_code"
                value={formData.user_code}
                onChange={handleChange}
                validation="numeric"
                placeholder="Ingrese código"
                horizontal={false}
              />

              <InputField
                title="División de personal"
                name="personnel_division"
                value={formData.personnel_division}
                onChange={handleChange}
                placeholder="Ingrese división de personal"
                horizontal={false}
              />

              <InputField
                title="Posición"
                name="position"
                value={formData.position}
                onChange={handleChange}
                placeholder="Ingrese posición"
                horizontal={false}
              />

              <InputField
                title="Gerencia jerárquica"
                name="hierarchichal_manage"
                value={formData.hierarchichal_manage}
                onChange={handleChange}
                placeholder="Ingrese gerencia jerárquica"
                horizontal={false}
              />

              <InputField
                title="Área funcional"
                name="functional_area"
                value={formData.functional_area}
                onChange={handleChange}
                placeholder="Ingrese área funcional"
                horizontal={false}
              />
            </div>

            {error && (
              <div className="p-2 mt-2 text-red-600 bg-red-100 rounded-md">
                {error}
              </div>
            )}
              
              <div className="flex items-center justify-center pt-4 space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-gray-700 border border-gray-300 rounded-md font-itcmedium hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-white rounded-md font-itcmedium bg-blue"
                >
                  {loading ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditGuest;